/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Credentials_Update_Email_TitleInputs */

const de_account_credentials_update_email_title = /** @type {(inputs: Account_Credentials_Update_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse ändern`)
};

/** @type {(inputs: Account_Credentials_Update_Email_TitleInputs) => LocalizedString} */
const en_account_credentials_update_email_title = de_account_credentials_update_email_title;

/**

* @param {Account_Credentials_Update_Email_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const account_credentials_update_email_title = /** @type {((inputs?: Account_Credentials_Update_Email_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Credentials_Update_Email_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_account_credentials_update_email_title(inputs)
	return en_account_credentials_update_email_title(inputs)
});